module.exports = __webpack_public_path__ + "static/media/reblozyl-graphic-1.cb4d25a5.png";